
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { AddNewGuestRequest, Traveller } from '../../model/checkout/guest-info.model';
import { ActHttpService } from '../act-http/act-http.service';

@Injectable()
export class GuestInfoService {

    private savingGuest: Traveller[] = [];
    private savingGuestCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    private travellersObj: BehaviorSubject<Traveller[]> = new BehaviorSubject<Traveller[]>([]);

    constructor(
        private actHttp: ActHttpService,
    ) { }

    // ***************** Guest Suggestion ************************ //
    getTravellerList(): Observable<AddNewGuestRequest> {
        const url = `${environment.endpoint.travellerManagement}s`;
        return this.actHttp.get(url, this.actHttp.getRequestOptions()).map((res: Response) => res.json());
    }

    addNewGuest(request: AddNewGuestRequest): Observable<any> {
        const url = `${environment.endpoint.travellerManagement}`;
        return this.actHttp.post(url, request, this.actHttp.getRequestOptions()).map((res) => res.json());
    }

    deleteGuest(travellerId: number): Observable<any> {
        const url = `${environment.endpoint.travellerManagement}/${travellerId}`;
        return this.actHttp.delete(url, this.actHttp.getRequestOptions());
    }

    addSavingGuest(traveller: Traveller) {
        this.savingGuest.push(traveller);
    }

    clearSavingGuest() {
        this.savingGuest = [];
    }

    getSavingGuest(): Traveller[] {
        this.savingGuest.forEach(guest => {
            delete guest.owned;
            delete guest.selected;
            delete guest.selecting;
        });
        return this.savingGuest;
    }

    setSavingGuestCount$(count: number) {
        this.savingGuestCount.next(count);
    }

    getSavingGuestCount$(): BehaviorSubject<number> {
        return this.savingGuestCount;
    }

    getSavingGuestCount(): number {
        return this.savingGuestCount.value;
    }

    setTravellers$(travellers: Traveller[]) {
        this.travellersObj.next(travellers);
    }

    getTravellers$(): BehaviorSubject<Traveller[]> {
        return this.travellersObj;
    }

    onCompleteSaveGuest() {
        this.setTravellers$(null);
        this.clearSavingGuest();
        this.setSavingGuestCount$(0);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/checkout/guest-info.service.ts